export const GET_RECOMMENDATIONS_LIST_DATA = 'GET_RECOMMENDATIONS_LIST_DATA'
export const SET_RECOMMENDATIONS_LOADING = 'SET_RECOMMENDATIONS_LOADING'
export const CLEAR_RECOMMENDATIONS = 'CLEAR_RECOMMENDATIONS'
